export default class ProfileModel {
    constructor(obj){
        obj = obj || {};
        // The parseInt is needed for the v-autocomplete mapping
        this.id = parseInt(obj.id);
        this.description = obj.description;
        this.createdAt = obj.createdAt;
        this.updatedAt = obj.updatedAt;
    }
}